import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08f87295"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_section" }
const _hoisted_2 = ["data-url"]
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<section class=\"desc_section\" data-v-08f87295><p class=\"title\" data-v-08f87295>최저가 신고 보상제란?</p><p class=\"desc\" data-v-08f87295> 구매한 링고라 수강권이 타사 수강권보다 저렴하지 <span class=\"showOnlyMobile\" data-v-08f87295><br data-v-08f87295></span> 않다면 최초 신고자에게는 <b class=\"brown\" data-v-08f87295>차액의 최대 10배</b> 를, <br data-v-08f87295> 최초 신고자와 동일한 조건의 수강권을 <span class=\"showOnlyMobile\" data-v-08f87295><br data-v-08f87295></span> 구매한 모든 분께는 <b class=\"brown\" data-v-08f87295>차액만큼 보상</b> 해드리고, <br data-v-08f87295> 링고라는 업계최저가 기준에 맞추어 가격을 조정합니다. </p></section>", 1)
const _hoisted_4 = { class: "benefit_section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "최저가 신고 혜택", -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc" }, "차액 최대 10배 보상", -1 /* HOISTED */))
const _hoisted_7 = ["data-url"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc desc_small" }, [
  /*#__PURE__*/_createTextVNode(" *해당 혜택은 최저가 보상 조건 심사가 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 통과된 경우에 지급됩니다. ")
], -1 /* HOISTED */))
const _hoisted_9 = { class: "benefit_card" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"benefit_card_label\" data-v-08f87295>신청 대상</div><div class=\"benefit_card_desc\" data-v-08f87295>2022년 11월 23일 이후 링고라 수강권 구매 고객</div><div class=\"benefit_card_label\" data-v-08f87295>신청 대상 수강권</div><div class=\"benefit_card_desc\" data-v-08f87295>365올패스 스탠다드 (글로벌)</div><div class=\"benefit_card_label\" data-v-08f87295>신청 기간</div><div class=\"benefit_card_desc\" data-v-08f87295>링고라 수강권 구매 후 1개월 이내</div><div class=\"benefit_card_label\" data-v-08f87295>보상 조건</div>", 7)
const _hoisted_17 = ["data-url"]
const _hoisted_18 = ["data-url"]
const _hoisted_19 = {
  key: 0,
  class: "benefit_card_collapse_contents"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { style: {"text-decoration":"underline"} }, "구매일", -1 /* HOISTED */))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_22 = ["data-url"]
const _hoisted_23 = ["data-url"]
const _hoisted_24 = {
  key: 1,
  class: "benefit_card_collapse_contents"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", {
    class: "benefit_card_list_item",
    style: {"color":"#85808d"}
  }, "최초 신고 고객의 접수일자: 2022년 12월 10일"),
  /*#__PURE__*/_createElementVNode("li", {
    class: "benefit_card_list_item",
    style: {"color":"#85808d"}
  }, " 최초 신고 고객의 수강권 구매일: 2022년 11월 30일 ")
], -1 /* HOISTED */))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"benefit_card_label\" style=\"margin-top:20px;\" data-v-08f87295>차액 보상 금액</div><div class=\"benefit_card_desc\" style=\"margin-bottom:0;\" data-v-08f87295><ul data-v-08f87295><li class=\"benefit_card_list_item\" data-v-08f87295>차액 금액은 1만원 단위 올림 적용하여 보상</li><li class=\"benefit_card_list_item\" data-v-08f87295>1만원 미만 차액은 1만원으로 동일 보상</li><li class=\"benefit_card_list_item\" style=\"color:#85808d;\" data-v-08f87295> 차액 = 구매 시점의 링고라 수강권 상시 판매가 - 동일 시점의 타사 수강권 상시 판매가 </li></ul></div>", 2)
const _hoisted_32 = { class: "report_reward_section" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "신고 접수 방법", -1 /* HOISTED */))
const _hoisted_34 = { class: "card_container" }
const _hoisted_35 = { class: "card" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "STEP. 1", -1 /* HOISTED */))
const _hoisted_37 = ["data-url"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createTextVNode(" 최저가 보상 기준 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 및 참여자 조건 확인 ")
], -1 /* HOISTED */))
const _hoisted_39 = { class: "card" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "STEP. 2", -1 /* HOISTED */))
const _hoisted_41 = ["data-url"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createTextVNode(" 양식을 작성하여 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 이메일로 신청 접수 ")
], -1 /* HOISTED */))
const _hoisted_43 = { class: "card" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "STEP. 3", -1 /* HOISTED */))
const _hoisted_45 = ["data-url"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createTextVNode(" 보상 기준에 따라 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 심사 진행 ")
], -1 /* HOISTED */))
const _hoisted_47 = { class: "card" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "STEP. 4", -1 /* HOISTED */))
const _hoisted_49 = ["data-url"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createTextVNode(" 심사 결과에 따라 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "리워드 지급")
], -1 /* HOISTED */))
const _hoisted_51 = {
  key: 0,
  class: "common-modal common-modal--dimmed",
  style: {"display":"block"}
}
const _hoisted_52 = { class: "common-modal__modal modal__certificate" }
const _hoisted_53 = /*#__PURE__*/_createStaticVNode("<div class=\"common-modal__content\" data-v-08f87295><h1 class=\"title\" data-v-08f87295> 최저가 신고 보상제 <br data-v-08f87295> 신청 양식 </h1><div class=\"description\" data-v-08f87295> 아래 양식을 작성하여 <br data-v-08f87295> contact@tutoring.co.kr로 이메일을 보내주세요. </div><div class=\"card\" data-v-08f87295><div class=\"line\" data-v-08f87295><span class=\"number\" data-v-08f87295>1</span><span data-v-08f87295>링고라 가입 이메일 계정</span></div><div class=\"line\" data-v-08f87295><span class=\"number\" data-v-08f87295>2</span><span data-v-08f87295>링고라에서 구매한 수강권</span></div><div class=\"line\" data-v-08f87295><span class=\"number\" data-v-08f87295>3</span><span data-v-08f87295>링고라 수강권 구매 일자</span></div><div class=\"line\" data-v-08f87295><span class=\"number\" data-v-08f87295>4</span><span data-v-08f87295>타사 수강권 판매 업체</span></div><div class=\"line\" data-v-08f87295><span class=\"number\" data-v-08f87295>5</span><span data-v-08f87295>타사 수강권명 &amp; 가격</span></div><div class=\"line\" data-v-08f87295><span class=\"number\" data-v-08f87295>6</span><span data-v-08f87295>타사 수강권 판매 일자</span></div><div class=\"line\" data-v-08f87295><span class=\"number\" data-v-08f87295>7</span><span data-v-08f87295> 타사 수강권의 판매 일자를 확인할 <br data-v-08f87295><span style=\"margin-left:24px;\" data-v-08f87295>수 있는 캡처화면이나 이미지 등을</span><br data-v-08f87295><span style=\"margin-left:24px;\" data-v-08f87295>첨부해주세요.</span><div class=\"small_text\" style=\"margin-top:4px;margin-left:24px;\" data-v-08f87295> ex. 캡처일자가 포함된 이미지, 정가/상시판매가/ <br data-v-08f87295> 할인액 확인이 가능한 타사 결제 상세 내역. </div></span></div></div><div class=\"notice\" data-v-08f87295><div class=\"title\" data-v-08f87295>유의사항</div><ul style=\"margin-left:10px;\" data-v-08f87295><li class=\"list__item\" data-v-08f87295> 링고라 수강권을 구매한 시점의 타사 수강권 상시 판매가를 기준으로 최저가 여부를 심사합니다. </li><li class=\"list__item\" data-v-08f87295> 구매 시점과 판매 시점이 상이한 경우 최저가 보상이 불가능하니 이 점 유의하여 접수해주시기 바랍니다. </li></ul></div></div>", 1)
const _hoisted_54 = { class: "low_price_report" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 최저가 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 신고 접수 현황 ")
], -1 /* HOISTED */))
const _hoisted_56 = {
  key: 0,
  class: "report__slide__wrapper"
}
const _hoisted_57 = { class: "course__slide" }
const _hoisted_58 = { class: "none_title" }
const _hoisted_59 = { class: "none_desc" }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "course__slide" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "심사 중", -1 /* HOISTED */))
const _hoisted_63 = { class: "plan_name" }
const _hoisted_64 = { class: "purchase_date" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "심사 중", -1 /* HOISTED */))
const _hoisted_66 = { class: "plan_name" }
const _hoisted_67 = { class: "purchase_date" }
const _hoisted_68 = { class: "course__slide" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "보상 완료", -1 /* HOISTED */))
const _hoisted_70 = { class: "plan_name" }
const _hoisted_71 = { class: "purchase_date" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "보상 완료", -1 /* HOISTED */))
const _hoisted_73 = { class: "plan_name" }
const _hoisted_74 = { class: "purchase_date" }
const _hoisted_75 = { class: "low_price_section" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 최저가 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 신고 보상 조건 ")
], -1 /* HOISTED */))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc" }, [
  /*#__PURE__*/_createTextVNode(" 영어회화 수업의 퀄리티를 좌우하는 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 아래 요소를 모두 갖추고 있는 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 1:1 영어회화 수강권이어야 합니다. ")
], -1 /* HOISTED */))
const _hoisted_78 = { class: "card" }
const _hoisted_79 = ["data-url"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card_title" }, "엄격한 튜터 채용 및 운영 관리", -1 /* HOISTED */))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card_desc" }, [
  /*#__PURE__*/_createTextVNode(" 수업에서 가장 중요한 튜터를 채용하고 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 트레이닝 후 실제 수업 진행 상황 모니터링까지 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 모두 직접 진행하여야 합니다. ")
], -1 /* HOISTED */))
const _hoisted_82 = ["data-url"]
const _hoisted_83 = { class: "card" }
const _hoisted_84 = ["data-url"]
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card_title" }, "수업하는 튜터의 전문성", -1 /* HOISTED */))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card_desc" }, [
  /*#__PURE__*/_createTextVNode(" 관련 학과 졸업증명서 혹은 티칭 자격증 보유하고 있고, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 교육 기관에서의 티칭 경력이 있는 튜터가 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 1:1영어회화 수업을 진행해야 합니다. ")
], -1 /* HOISTED */))
const _hoisted_87 = ["data-url"]
const _hoisted_88 = { class: "card" }
const _hoisted_89 = ["data-url"]
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card_title" }, "100명 이상의 대규모 튜터풀", -1 /* HOISTED */))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card_desc" }, [
  /*#__PURE__*/_createTextVNode(" 링고라의 대규모 튜터풀과 비교 가능한 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 글로벌 100명 이상, 원어민 50명 이상을 체계적으로 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 관리하는 경우만 보상 조건에 포함됩니다. ")
], -1 /* HOISTED */))
const _hoisted_92 = ["data-url"]
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card_desc_small" }, [
  /*#__PURE__*/_createTextVNode(" *링고라 튜터 수: 글로벌(영어 사용국) 450명 이상, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 원어민(영어 모국어) 90명 이상 ")
], -1 /* HOISTED */))
const _hoisted_94 = { class: "card" }
const _hoisted_95 = ["data-url"]
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card_title" }, [
  /*#__PURE__*/_createTextVNode(" 체계적인 커리큘럼 설계 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 및 수업 콘텐츠 개발 ")
], -1 /* HOISTED */))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card_desc" }, [
  /*#__PURE__*/_createTextVNode(" 각 레벨별 체계적인 커리큘럼이 있어야 하며, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 커리큘럼에 맞는 수업 교재를 직접 연구하고 제작하여 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 수업에 활용하여야 합니다. ")
], -1 /* HOISTED */))
const _hoisted_98 = ["data-url"]
const _hoisted_99 = /*#__PURE__*/_createStaticVNode("<section class=\"notice_section\" data-v-08f87295><div class=\"container\" data-v-08f87295><p class=\"title\" data-v-08f87295>이벤트 유의사항</p><ul data-v-08f87295><li class=\"list__item\" data-v-08f87295> 최저가 신고는 위 신청 조건 및 양식을 확인하시어 링고라 이메일로 접수해주시기 바랍니다. (contact@tutoring.co.kr) </li><li class=\"list__item\" data-v-08f87295> 링고라 회원으로 구매한 내역이 확인되지 않거나 신고 양식에 맞지 않는 경우 신고가 취소될 수 있으며, 보상은 신고자 본인에게만 제공됩니다. </li><li class=\"list__item\" data-v-08f87295>보상 혜택으로 지급되는 상품권은 모바일 상품권으로 SMS통해 지급됩니다.</li><li class=\"list__item\" data-v-08f87295><b data-v-08f87295>수강권별 최초 신고자*</b> 에 한해 심사 완료 후 차액의 10배 상당 모바일 상품권이 지급되며, 최초 신고 후 보상 완료된 수강권의 구매일~접수일 사이에 동일한 수강권을 구매한 고객 전원( <b data-v-08f87295>최저가 일반 보상 대상자**</b> )에게는 차액 상당의 모바일 상품권이 지급됩니다. </li><li class=\"title_small\" style=\"margin-top:20px;\" data-v-08f87295><b data-v-08f87295>[수강권별 최초 신고자* 기준]</b></li><li class=\"list__item\" data-v-08f87295>최저가 신고 접수 후 최초로 보상이 완료된 건을 의미합니다.</li><li class=\"list__item\" data-v-08f87295>접수 순번은 보상 신고 접수하시면 이메일로 회신드릴 예정입니다.</li><li class=\"list__item\" data-v-08f87295> 최초 신고자의 신고 건 심사 후 보상 기준에 충족되지 않은 경우 차순위 접수자의 신고 건에 대한 심사를 진행합니다. </li><li class=\"list__item\" data-v-08f87295> 보상을 받은 후 수강권을 재구매한 경우, 재구매 일자의 수강권 판매 가격으로 추가 신고 접수가 가능합니다. </li><li class=\"list__item\" style=\"margin-bottom:20px;\" data-v-08f87295> 최초 신고자로 심사 통과된 경우 차액의 10배 보상이 지급되며, 최저가 일반 보상과는 중복 지급되지 않습니다. </li><li class=\"title_small\" style=\"margin-top:20px;\" data-v-08f87295><b data-v-08f87295>[최저가 일반 보상자** 기준]</b></li><li class=\"list__item\" data-v-08f87295> 최저가 신고 접수 후 보상이 완료된 수강권을 최초 신고 고객의 수강권 구매 일자와 신고 접수 일자 사이에 동일한 가격으로 구매한 고객을 의미합니다. </li><li class=\"list__item_none\" style=\"margin-left:20px;\" data-v-08f87295> - 예시) “[365 올패스] Global 12개월 96회 20분” 최저가 신고 접수 </li><li class=\"list__item_none\" style=\"margin-left:20px;\" data-v-08f87295>- 최초 신고 고객의 접수일자: 2022년 12월 10일</li><li class=\"list__item_none\" style=\"margin-left:20px;\" data-v-08f87295>- 최초 신고 고객의 수강권 구매일: 2022년 11월 30일</li><li class=\"list__item_none\" style=\"margin-left:20px;\" data-v-08f87295> → <b data-v-08f87295>최저가 일반 보상 대상자</b> : 2022년 11월 30일~2022년 12월 10일 중 [365 올패스] Global 12개월 96회 20분 수강권을 구매한 모든 고객 (환불 제외) </li><li class=\"list__item\" data-v-08f87295> 최저가 일반 보상자는 최저가 신고 여부와 상관없이 조건이 충족되는 모든 고객에 차액 상당의 상품권으로 보상이 지급될 예정입니다. </li><li class=\"list__item\" style=\"margin-bottom:20px;\" data-v-08f87295> 최저가 일반 보상 대상자의 경우 최초 신고자에 대한 심사 완료 후 개별적으로 보상 관련 안내를 드릴 예정입니다. </li><li class=\"list__item\" data-v-08f87295>보상 신고 후 심사까지는 영업일 기준 최대 10일이 소요될 수 있습니다.</li><li class=\"list__item\" data-v-08f87295>본 이벤트는 사전 예고없이 변경, 종료될 수 있습니다.</li><li class=\"list__item\" data-v-08f87295> 관련 문의 사항은 링고라 앱 내 [고객센터 &gt; 1:1 채팅문의] 혹은 이메일(contact@tutoring.co.kr)로 연락주시기 바랍니다. </li></ul><p class=\"title\" data-v-08f87295>최저가 신고 보상제 상세 기준</p><ul data-v-08f87295><li class=\"list__item\" data-v-08f87295>서비스 비교 조건 4가지와 수강권 비교 조건이 모두 충족되어야 보상이 가능합니다.</li><li class=\"title_small\" style=\"margin-top:20px;\" data-v-08f87295><b data-v-08f87295>[서비스 조건 충족 기준]</b></li><li class=\"list__item\" data-v-08f87295> 튜터 직접 채용/교육/모니터링: 업체에서 튜터를 직접 채용하고트레이닝 및 모니터링까지 모두 직접 진행하여야 합니다. </li><li class=\"list__item\" data-v-08f87295> 튜터의 전문성: 채용된 튜터는 모두 관련 학과 졸업증명서 혹은 티칭 자격증 보유하고 있거나 2년 이상의 티칭 경력이 있어야 합니다. </li><li class=\"list__item\" data-v-08f87295> 대규모 튜터풀: 글로벌(영어 사용국) 튜터가 100명 이상, 원어민(영어 모국어)튜터 50명 이상을 체계적으로 관리하여야 합니다. </li><li class=\"list__item\" data-v-08f87295> 레벨별 커리큘럼 및 수업자료: 각 레벨별 체계적인 커리큘럼이 있어야 하며, 커리큘럼에 따라 교재/자료를 활용하여 수업이 진행되어야 합니다. </li><li class=\"list__item\" data-v-08f87295> 타사 수강권 판매처의 서비스가 4가지 기준에 모두 부합하여야 하며, 실제 조건이 충족되지만 공식 홈페이지나 소개자료, 고객 문의 등에서 확인이 불가한 경우에는 보상이 불가합니다. </li><li class=\"title_small\" style=\"margin-top:20px;\" data-v-08f87295><b data-v-08f87295>[수강권 비교 기준]</b></li><li class=\"list__item\" data-v-08f87295> 최저가 비교 수강권의 가격은 별도 프로모션이 적용되지 않은 상시 판매가를 기준으로 합니다. </li><li class=\"list__item\" data-v-08f87295> 판매처별 수강권 판매 옵션이 상이한 경우 총 판매가 기준 분당 가격 동일 조건 판매시로 금액을 환산하여 가격을 비교합니다. (수강권 분당단가 = (총 수업 횟수*수업당 분수)/판매가) </li><li class=\"list__item\" data-v-08f87295> 링고라의 경우 모든 시간대 실시간 수업이 가능하기 때문에 특정 시간대나 요일 조건부 할인이 적용되지 않은 상시 이용 조건의 수강권과 최우선으로 비교하며, 만약 신고 보상 조건에는 부합되지만 상시 수업 가능한 수강권이 없는 경우, 새벽 시간대 제외 (KST 0시 ~ 6시) 모든 시간대 수업의 가격이 동일한 정규 수강권으로 비교하여야 합니다. 동일 기간, 총 시간(분수)의 자유 수강권과 정규 수강권이 모두 존재하는 경우 자유 수강권을 기준으로 비교합니다. </li><li class=\"list__item\" style=\"margin-left:20px;\" data-v-08f87295> ex. 09~16시 중 시간 지정 수강권 (신고 불가) / 06~24시 중 시간 지정 수강권 (신고 가능) / 06~24시 중 자유 수강권 (신고 가능) </li><li class=\"list__item\" data-v-08f87295> 수강권 외 별도 교재나 상품 등이 결합된 상품은 신고 대상에서 제외됩니다. (ex. 전자 기기결합 수강권 등) </li><li class=\"list__item\" data-v-08f87295> 링고라 수강권과 가격 비교가 어려운 경우(ex. 튜터별 수강료가 상이한 경우)는 신고 대상에서 제외됩니다. </li><li class=\"list__item\" data-v-08f87295>링고라 수강권 중 최저가 신고 대상은 365올패스 스탠다드 상품입니다.</li></ul></div></section>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppNav = _resolveComponent("AppNav")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _directive_img_lazy_loading = _resolveDirective("img-lazy-loading")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" app nav "),
    ($options.appView)
      ? (_openBlock(), _createBlock(_component_AppNav, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode("최저가 신고 보상제")
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: "promotion",
      style: _normalizeStyle({ 'padding-top': $options.appPadding })
    }, [
      _createElementVNode("section", _hoisted_1, [
        _withDirectives(_createElementVNode("img", {
          "data-url": $data.imgUrls.main_img,
          class: "main_img",
          alt: "main_img"
        }, null, 8 /* PROPS */, _hoisted_2), [
          [_directive_img_lazy_loading]
        ])
      ]),
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _withDirectives(_createElementVNode("img", {
          "data-url": $data.imgUrls.marketprice_reward,
          class: "img_gift_card",
          alt: "marketprice_reward"
        }, null, 8 /* PROPS */, _hoisted_7), [
          [_directive_img_lazy_loading]
        ]),
        _hoisted_8,
        _createCommentVNode(" <img v-img-lazy-loading :data-url=\"imgUrls.reward_table\" class=\"img_table\" alt=\"reward_table\" /> "),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", {
            class: "benefit_card_collapse_button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.toggleCollapse1 && $options.toggleCollapse1(...args)))
          }, [
            _createTextVNode(" 최저가 최초 신고자 : 차액 10배 보상 "),
            (!$data.isOpenCollapse1)
              ? _withDirectives((_openBlock(), _createElementBlock("img", {
                  key: 0,
                  "data-url": $data.imgUrls.ic_arrow_down,
                  class: "icon"
                }, null, 8 /* PROPS */, _hoisted_17)), [
                  [_directive_img_lazy_loading]
                ])
              : _createCommentVNode("v-if", true),
            ($data.isOpenCollapse1)
              ? _withDirectives((_openBlock(), _createElementBlock("img", {
                  key: 1,
                  "data-url": $data.imgUrls.ic_arrow_up,
                  class: "icon"
                }, null, 8 /* PROPS */, _hoisted_18)), [
                  [_directive_img_lazy_loading]
                ])
              : _createCommentVNode("v-if", true)
          ]),
          ($data.isOpenCollapse1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createTextVNode(" 링고라 수강권 "),
                _hoisted_20,
                _createTextVNode(" 에 동일 조건의 타사 수강권 상시 판매가가 더 저렴한 것을 최초로 신고하여 심사가 통과된 경우 차액 10배 보상 "),
                _hoisted_21,
                _createTextVNode(" (링고라 수강권 구매시점과 타사 수강권 판매 시점 동일 조건) ")
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", {
            class: "benefit_card_collapse_button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.toggleCollapse2 && $options.toggleCollapse2(...args)))
          }, [
            _createTextVNode(" 최저가 일반 보상 대상자 : 차액 보상 "),
            (!$data.isOpenCollapse2)
              ? _withDirectives((_openBlock(), _createElementBlock("img", {
                  key: 0,
                  "data-url": $data.imgUrls.ic_arrow_down,
                  class: "icon"
                }, null, 8 /* PROPS */, _hoisted_22)), [
                  [_directive_img_lazy_loading]
                ])
              : _createCommentVNode("v-if", true),
            ($data.isOpenCollapse2)
              ? _withDirectives((_openBlock(), _createElementBlock("img", {
                  key: 1,
                  "data-url": $data.imgUrls.ic_arrow_up,
                  class: "icon"
                }, null, 8 /* PROPS */, _hoisted_23)), [
                  [_directive_img_lazy_loading]
                ])
              : _createCommentVNode("v-if", true)
          ]),
          ($data.isOpenCollapse2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createTextVNode(" 최초 신고 접수한 고객의 구매일부터 신고 접수일 사이에 동일 수강권을 구매한 모든 고객에 차액 상당 보상 (신고여부 무관) "),
                _hoisted_25,
                _hoisted_26,
                _createTextVNode(" ex. \"[365 올패스] Global 12개월 96회 20분\" 최저가 신고 접수 "),
                _hoisted_27,
                _hoisted_28,
                _createTextVNode(" → 최저가 일반 보상 대상자 (차액 보상) "),
                _hoisted_29,
                _createTextVNode(" 2022년 11월 30일~2022년 12월 10일 중 [365 올패스] Global 12개월 96회 20분 수강권을 구매한 모든 고객 (환불 제외) ")
              ]))
            : _createCommentVNode("v-if", true),
          _hoisted_30
        ])
      ]),
      _createElementVNode("section", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _withDirectives(_createElementVNode("img", {
              "data-url": $data.imgUrls.emoji_01,
              class: "icon",
              alt: "icon"
            }, null, 8 /* PROPS */, _hoisted_37), [
              [_directive_img_lazy_loading]
            ]),
            _hoisted_38
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _withDirectives(_createElementVNode("img", {
              "data-url": $data.imgUrls.emoji_02,
              class: "icon",
              alt: "icon"
            }, null, 8 /* PROPS */, _hoisted_41), [
              [_directive_img_lazy_loading]
            ]),
            _hoisted_42
          ]),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _withDirectives(_createElementVNode("img", {
              "data-url": $data.imgUrls.emoji_03,
              class: "icon",
              alt: "icon"
            }, null, 8 /* PROPS */, _hoisted_45), [
              [_directive_img_lazy_loading]
            ]),
            _hoisted_46
          ]),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _withDirectives(_createElementVNode("img", {
              "data-url": $data.imgUrls.emoji_04,
              class: "icon",
              alt: "icon"
            }, null, 8 /* PROPS */, _hoisted_49), [
              [_directive_img_lazy_loading]
            ]),
            _hoisted_50
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "button_form",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.openSample && $options.openSample(...args)))
        }, "신청 양식 확인하기")
      ]),
      _createCommentVNode(" 신청 양식 확인하기 클릭시 나오는 부분 "),
      ($data.isSampleClicked)
        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("button", {
                type: "button",
                class: "modal__certificate__close",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.openSample && $options.openSample(...args)))
              }, "닫기")
            ])), [
              [_directive_click_outside, $options.openSample]
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("section", _hoisted_54, [
        _hoisted_55,
        ($data.lowReportIng.length === 0 && $data.lowReportDone.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createVNode(_component_swiper, {
                  "slides-per-view": 3,
                  "space-between": 18,
                  centeredSlides: true,
                  slideToClickedSlide: true,
                  initialSlide: 0
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_swiper_slide, { class: "slide__card none_both" }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_58, _toDisplayString($data.lowReportBothNone.title), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_59, _toDisplayString($data.lowReportBothNone.desc), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($data.lowReportIng.length !== 0 || $data.lowReportDone.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
              _createElementVNode("div", {
                class: _normalizeClass(["report__slide__wrapper", { fix_width: $data.lowReportIng.length < 3 }])
              }, [
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_component_swiper, {
                    "slides-per-view": 3,
                    "space-between": 18,
                    centeredSlides: true,
                    slideToClickedSlide: true,
                    initialSlide: 0
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.lowReportIng, (ing) => {
                        return (_openBlock(), _createBlock(_component_swiper_slide, {
                          class: "slide__card",
                          key: ing
                        }, {
                          default: _withCtx(() => [
                            _hoisted_62,
                            _createElementVNode("p", _hoisted_63, _toDisplayString(ing.title), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_64, _toDisplayString(ing.date) + " 구매 기준", 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */))
                      }), 128 /* KEYED_FRAGMENT */)),
                      ($data.lowReportIng.length === 0)
                        ? (_openBlock(), _createBlock(_component_swiper_slide, {
                            key: 0,
                            class: "slide__card none"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_65,
                              _createElementVNode("p", _hoisted_66, _toDisplayString($data.lowReportIngNone.title), 1 /* TEXT */),
                              _createElementVNode("p", _hoisted_67, _toDisplayString($data.lowReportIngNone.desc), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ], 2 /* CLASS */),
              _createElementVNode("div", {
                class: _normalizeClass(["report__slide__wrapper", { fix_width: $data.lowReportDone.length < 3 }])
              }, [
                _createElementVNode("div", _hoisted_68, [
                  _createVNode(_component_swiper, {
                    "slides-per-view": 3,
                    "space-between": 18,
                    centeredSlides: true,
                    slideToClickedSlide: true,
                    initialSlide: 0
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.lowReportDone, (done) => {
                        return (_openBlock(), _createBlock(_component_swiper_slide, {
                          class: "slide__card",
                          key: done
                        }, {
                          default: _withCtx(() => [
                            _hoisted_69,
                            _createElementVNode("p", _hoisted_70, _toDisplayString(done.title), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_71, _toDisplayString(done.date) + " 구매 기준", 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */))
                      }), 128 /* KEYED_FRAGMENT */)),
                      ($data.lowReportDone.length === 0)
                        ? (_openBlock(), _createBlock(_component_swiper_slide, {
                            key: 0,
                            class: "slide__card none"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_72,
                              _createElementVNode("p", _hoisted_73, _toDisplayString($data.lowReportDoneNone.title), 1 /* TEXT */),
                              _createElementVNode("p", _hoisted_74, _toDisplayString($data.lowReportDoneNone.desc), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ], 2 /* CLASS */)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("section", _hoisted_75, [
        _hoisted_76,
        _hoisted_77,
        _createElementVNode("div", _hoisted_78, [
          _withDirectives(_createElementVNode("img", {
            "data-url": $data.imgUrls.reward_number01,
            class: "card_number",
            alt: "main_img"
          }, null, 8 /* PROPS */, _hoisted_79), [
            [_directive_img_lazy_loading]
          ]),
          _hoisted_80,
          _hoisted_81,
          _withDirectives(_createElementVNode("img", {
            "data-url": $data.imgUrls.reward_img01,
            class: "card_img",
            alt: "main_img"
          }, null, 8 /* PROPS */, _hoisted_82), [
            [_directive_img_lazy_loading]
          ])
        ]),
        _createElementVNode("div", _hoisted_83, [
          _withDirectives(_createElementVNode("img", {
            "data-url": $data.imgUrls.reward_number02,
            class: "card_number",
            alt: "main_img"
          }, null, 8 /* PROPS */, _hoisted_84), [
            [_directive_img_lazy_loading]
          ]),
          _hoisted_85,
          _hoisted_86,
          _withDirectives(_createElementVNode("img", {
            "data-url": $data.imgUrls.reward_img02,
            class: "card_img",
            alt: "main_img"
          }, null, 8 /* PROPS */, _hoisted_87), [
            [_directive_img_lazy_loading]
          ])
        ]),
        _createElementVNode("div", _hoisted_88, [
          _withDirectives(_createElementVNode("img", {
            "data-url": $data.imgUrls.reward_number03,
            class: "card_number",
            alt: "main_img"
          }, null, 8 /* PROPS */, _hoisted_89), [
            [_directive_img_lazy_loading]
          ]),
          _hoisted_90,
          _hoisted_91,
          _withDirectives(_createElementVNode("img", {
            "data-url": $data.imgUrls.reward_img03,
            class: "card_img",
            alt: "main_img",
            style: {"margin-bottom":"13px"}
          }, null, 8 /* PROPS */, _hoisted_92), [
            [_directive_img_lazy_loading]
          ]),
          _hoisted_93
        ]),
        _createElementVNode("div", _hoisted_94, [
          _withDirectives(_createElementVNode("img", {
            "data-url": $data.imgUrls.reward_number04,
            class: "card_number",
            alt: "main_img"
          }, null, 8 /* PROPS */, _hoisted_95), [
            [_directive_img_lazy_loading]
          ]),
          _hoisted_96,
          _hoisted_97,
          _withDirectives(_createElementVNode("img", {
            "data-url": $data.imgUrls.reward_img04,
            class: "card_img",
            alt: "main_img"
          }, null, 8 /* PROPS */, _hoisted_98), [
            [_directive_img_lazy_loading]
          ])
        ])
      ]),
      _createCommentVNode(" 하단 유의 사항  "),
      _hoisted_99
    ], 4 /* STYLE */)
  ], 64 /* STABLE_FRAGMENT */))
}